<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 24a12.01 12.01 0 1 1 12-12c0 6.62-5.38 12-12 12m0-22a10.01 10.01 0 0 0 0 20 10.01 10.01 0 0 0 0-20m1 15V7a1 1 0 0 0-1.7-.7L8.84 8.73a1 1 0 1 0 1.41 1.41l.74-.74V17a1 1 0 1 0 2 0"/></svg>
</template>
